/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
import CPointLie from '../objets/CPointLie'
import CPointAncetrePointsMobiles from '../objets/CPointAncetrePointsMobiles'
export default CPointLie

CPointLie.prototype.lieA = function () {
  return null
}

CPointLie.prototype.compHist = function () {
  let res = CPointAncetrePointsMobiles.prototype.compHist.call(this)
  res += ' abscissa: ' + String(this.abscisse)
  return res
}
